export class Session {
  CommunityId:string;
  SessionId: string;
  UserId: string;
  UserName: string;
  DisplayName: string;
  Email: string;
  LastLogin: string;
  TimeZoneSetting: string;
  LanguageSetting: string;
  CurrentActivePath:string;
}

export class AppSession {
  HoldId:string;
  HoldMessage:string;
  Session:Session;
  HomeUrl:string[];
  SessionKey:string;
}

export enum SessionTimerStatus {
  START,
  RESET,
  STOP
}